import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxArchiveViewComponent } from './archive-view.component';

// TODO - remove when routesConfig ngx STAB-1182
export const ngxArchiveViewModule = angular.module('ngxArchiveViewModule', [])
	.directive('ngxArchiveView', downgradeComponent({ component: NgxArchiveViewComponent }))
	.name;
